import {Application} from "./application";
import {Customer, CustomersApi} from "./api/customers";

export default class IntercomManager {
    customers: CustomersApi;
    constructor(private app: Application) {
        this.customers = app.apiManager.customers;        
        this.customers.load().then((data) => {
            if (data){
                (<any>window).Intercom('boot', {
                    app_id: "m2nta5bd",
                    email: data.name,
                    horizontal_padding: 32
                });
            }
        })        
    }   
}



// WEBPACK FOOTER //
// ./ClientApp/services/intercomManager.ts